import { RouteRecordRaw } from 'vue-router';

const careCheckInRoutes: RouteRecordRaw[] = [
  {
    path: '/seeker/care-check-in/:token',
    name: 'seeker-care-check-in',
    component: () => import('@/apps/seeker/careCheckIn/SeekerCareCheckIn.vue'),
    props: true,
    meta: {
      hideMainHeader: true,
      skipAuth: true,
    },
  },
];

export default careCheckInRoutes;
